module.exports = __webpack_public_path__ + "static/img/no-data.4141ade2.png";